
import dayjs from 'dayjs' //日期时间处理组件
import http from './http';

var vue_user = null, vue_setting = null, vue_Dept = null, vue_Process = null, vue_fontBytes = null;

Object.defineProperty(this, 'vue_setting', {
    get: async function () {
        if (vue_setting) return vue_setting;
        await loadBaseData();
        return vue_setting;
    }
});
Object.defineProperty(this, 'vue_Dept', {
    get: async function () {
        if (vue_Dept) return vue_Dept;
        await loadBaseData();
        return vue_Dept;
    }
});

Object.defineProperty(this, 'vue_Process', {//得到 Enabled>0 ，需要使用的地方，去区分Enabled状态1、2、3，自行处理
    get: async function () {
        if (vue_Process) return vue_Process;
        await loadBaseData();
        return vue_Process;
    }
});

Object.defineProperty(this, 'vue_user', {
    get: function () {
        if (vue_user == null)
            vue_user = JSON.parse(localStorage.getItem("vue_user"))
        if (!vue_user || !dayjs(vue_user.ExpiresTime).isValid() || vue_user.ExpiresTime < dayjs().format() || !vue_user.Token) {
            vue_user = null;
            localStorage.clear();
        }
        return vue_user;
    },
    set: function (x) {
        vue_user = x;
        !x ? localStorage.clear() : localStorage.setItem('vue_user', JSON.stringify(vue_user));
    }
});

Object.defineProperty(this, 'vue_fontBytes', {
    get: async function () {
        if (vue_fontBytes) return vue_fontBytes;
        await loadFont();
        return vue_fontBytes;
    }
});

//使用Promise来模拟等待作用，避免同时多个向后端请求。
var wait = (checkFlag = '') => {
    var that = this;
    return new Promise(resolve => {
        let to = function () { that[checkFlag] ? setTimeout(to, 200) : resolve(); }
        to();
    });
}

//执行后台加载一些基础设置的数据
this.baseDataLoading = false;
var loadBaseData = async () => {
    if (this.baseDataLoading) { await wait('baseDataLoading'); }
    if (!vue_setting) {
        this.baseDataLoading = true;
        var postData = { 'apiID': '8F466E17-E5E9-4F23-A1CF-D0AEE622BFA7' };
        await http.post(sys.apiUrl, postData,{ showLoading: false }).then(res => {
            vue_setting = res.data.data.Table;//基础设置(出院后，必须提交病案的最长允许天数，等)
            vue_Dept = res.data.data.Table1;//科室数据
            vue_Process = res.data.data.Table2;//流程/状态的数据   得到 Enabled>0 ，需要使用的地方，去区分Enabled状态1、2、3，自行处理
        })
        this.baseDataLoading = false;
    }
}
var loadFont = async () => {
    const ttfUrl = await import('@/assets/font/AlibabaPuHuiTi-3-65-Medium.ttf');
    const res = await fetch(ttfUrl);
    vue_fontBytes = await res.arrayBuffer();

}
export default this;


// WEBPACK FOOTER //
// ./src/utils/baseData.js